package one.primehealth.analytics.events

sealed interface AppEvent {
    val name: String
    val properties: Map<String, Any?>?
        get() = null
    val userProperties: Map<String, Any?>
        get() = emptyMap()
    val critical: Boolean
        get() = false
}